export default __webpack_public_path__ + "static/media/icon-activity-registereduser.be6b6aa1.svg";